import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./slice";

const selectDomain = (state) => state.reportJobs || initialState;

export const selectReportJobs = createSelector(
  [selectDomain],
  (state) => state.jobs
);

export const selectReportJobsLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectReportJobsError = createSelector(
  [selectDomain],
  (state) => state.error
);

export const selectReportJobsPagination = createSelector(
  [selectDomain],
  (state) => state.pagination
);